import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/esnext.global-this.js";
import { ExtensionType, extensions } from '@pixi/core';
var ResizePlugin = /*#__PURE__*/function () {
  function ResizePlugin() {
    _classCallCheck(this, ResizePlugin);
  }
  _createClass(ResizePlugin, null, [{
    key: "init",
    value: function init(options) {
      var _this = this;
      Object.defineProperty(this, "resizeTo", {
        set: function set(dom) {
          globalThis.removeEventListener("resize", this.queueResize);
          this._resizeTo = dom;
          if (dom) {
            globalThis.addEventListener("resize", this.queueResize);
            this.resize();
          }
        },
        get: function get() {
          return this._resizeTo;
        }
      });
      this.queueResize = function () {
        if (!_this._resizeTo) {
          return;
        }
        _this.cancelResize();
        _this._resizeId = requestAnimationFrame(function () {
          return _this.resize();
        });
      };
      this.cancelResize = function () {
        if (_this._resizeId) {
          cancelAnimationFrame(_this._resizeId);
          _this._resizeId = null;
        }
      };
      this.resize = function () {
        if (!_this._resizeTo) {
          return;
        }
        _this.cancelResize();
        var width;
        var height;
        if (_this._resizeTo === globalThis.window) {
          width = globalThis.innerWidth;
          height = globalThis.innerHeight;
        } else {
          var _this$_resizeTo = _this._resizeTo,
            clientWidth = _this$_resizeTo.clientWidth,
            clientHeight = _this$_resizeTo.clientHeight;
          width = clientWidth;
          height = clientHeight;
        }
        _this.renderer.resize(width, height);
        _this.render();
      };
      this._resizeId = null;
      this._resizeTo = null;
      this.resizeTo = options.resizeTo || null;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      globalThis.removeEventListener("resize", this.queueResize);
      this.cancelResize();
      this.cancelResize = null;
      this.queueResize = null;
      this.resizeTo = null;
      this.resize = null;
    }
  }]);
  return ResizePlugin;
}();
ResizePlugin.extension = ExtensionType.Application;
extensions.add(ResizePlugin);
export { ResizePlugin };